<script>
import { mapGetters } from 'vuex'
import { inventoryMethods, warehouseMethods, pendingsMethods } from '@state/helpers'

export default {
  name: 'Pointer',
  props: {
    restorePendings: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      consult_warehouse: 'retina/warehouse/consult_warehouse',
      warehouse_i: 'retina/inventory/warehouse_i',
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_i: 'retina/inventory/ubication_i',
      ubication_selected: 'retina/warehouse/ubication_selected',
      inventory_count_mode: 'retina/inventory/inventory_count_mode',
      inventory_count_spent_products:
        'retina/inventory/inventory_count_spent_products',
      inventory_count_review: 'retina/inventory/inventory_count_review',
      inventory_online_mode: 'retina/inventory/inventory_online_mode',
    }),
  },
  methods: {
    ...inventoryMethods,
    ...warehouseMethods,
    ...pendingsMethods,
    statusInfo(value) {
      return (
        (value ? 'outline-success' : 'outline-secondary') + ' btn-transparent'
      )
    },
    async reset() {
      if(this.restorePendings === true){
        this.deletePendings()
      }
      this.$store.dispatch('retina/warehouse/clearWarehouse')
      this.$store.dispatch('retina/warehouse/clearUbication')
      this.setWarehouseI(null)
      this.setUbicacionI(null)
      this.disableInventoryCountSpentProducts()
      this.enableInventoryCountMode()
      this.clearInventory()
      this.setStock([])
      this.clearSpent()
      this.clearPending()
      this.setTotalPending(0)
      this.disableInventoryCountMode()
      this.setInventoryOnlineMode(false)
      this.setInventoryCountReview(false)
      this.setConsultWarehouse(true)
    },
    consultWarehouse() {
      return !this.warehouse_selected || !this.ubication_selected ? true 
              : this.inventory_count_mode ? false
              : this.inventory_count_review ? false
              : this.inventory_online_mode ? false 
              : this.inventory_count_spent_products ? false : true
    },
    async deletePendings(){
      let response = await this.deleteAllPendings(
        '?id_warehouse=' + this.warehouse_i.id +
        '&id_location=' + ( this.ubication_i && this.ubication_i.id || '')
        )
      console.log(response)
      if(response){
        if(response.count_deleted > 0){
          this.$generate_toast(this, 'success', `Se han limpiado los pendientes satisfactoriamente!`);
        } else {
          this.$generate_toast(this, 'warn', `No hay registros pendientes por limpiar, verifique`);
        }
        return true
      } else {
        this.$generate_toast(this, 'error', `Hubo un error intentando limpiar, reintente`);
        console.error("error", response)
      }
      return false
    }
  },
  beforeMount() {
    if (!this.warehouse_selected || !this.ubication_selected){
      this.setInventoryOnlineMode(false)
    }
  },
}
</script>
<template>
  <b-row class="d-flex justify-content-between mb-2">
    <b-col xs="12" sm="12" md="12">
      <div v-if="!restorePendings" class="p-0 m-0 d-inline">
        <b-button
          v-if="consultWarehouse()"
          variant="link"
          disabled
        >
          
          <span v-if="!warehouse_selected && !warehouse_i" class="text-danger"><i class="fa fa-exclamation-triangle"></i> Seleccionar bodega</span>
          <span v-else-if="!ubication_selected && !ubication_i" class="text-danger"><i class="fa fa-exclamation-triangle"></i> Seleccionar ubicación</span>
          <span v-else-if="(warehouse_selected && ubication_selected) || (warehouse_i && ubication_i)"  class="text-success"><i class="fas fa-check"></i> Bodega y ubicación seleccionadas</span>

        </b-button>
        <b-button
          v-if="inventory_online_mode && warehouse_selected && ubication_selected"
          :variant="statusInfo(inventory_online_mode)"
          disabled
        >
          <i class="fas fa-globe-americas"></i>
          Consultar inventario online
        </b-button>
        <b-button
          v-if="inventory_count_mode"
          :variant="statusInfo(inventory_count_mode)"
          disabled
        >
          <i class="fas fa-dolly-flatbed"></i>
          Contar productos en bodega
        </b-button>
        <b-button
          v-if="inventory_count_spent_products"
          :variant="statusInfo(inventory_count_spent_products)"
          disabled
        >
          <i class="fas fa-box-open"></i>
          Contar productos consumidos
        </b-button>
        <b-button
          v-if="inventory_count_review"
          :variant="statusInfo(inventory_count_review)"
          disabled
        >
          <i class="fas fa-clipboard-list"></i>
          Revisar Pedido
        </b-button>
      </div>
      <b-button @click="reset()" size="sm" variant="outline-danger" class="float-right" :data-type="restorePendings">
        <span v-if="!restorePendings"> <i class="fas fa-stopwatch"></i> Restablecer</span>
        <span v-else ><i class="fas fa-undo"></i> Limpiar Pendientes</span>
      </b-button>
    </b-col>
  </b-row>
</template>
<style lang="scss">
  .multiselect__option {
    white-space: normal;
    font-weight: 300;
    font-size: 14px;
  }
</style>
